import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchStatsConfig, type FetchStatsConfigParams } from '../../api/fetchers/stats/fetcher';

export const fetchStatsConfigAction = createAsyncThunk(
  'statsConfig/fetchStatsConfig',
  (params: FetchStatsConfigParams) => fetchStatsConfig(params)
);
